import { FC, useState, useEffect, useMemo } from 'react'
import Swal from 'sweetalert2'
import { StatusLoteModalProps } from '../type'
import { useProduct } from '../factory/useProduct'
import { i18n } from '../../../../../../translate/i18n'
import { POST } from '../../../../../../services/api'
import { ModularDataTable, TableSelection } from '../../../../../../components/ModularDataTable'
import { createColumns } from '../factory/generateColumns'
import usePluginsSpace from '../../../../../../hooks/usePluginSpace'
import { FilterOptions } from '../components/filterOptions'
import { GridSelectionModal } from '../../../../../Hospitality/ContentStructured/ServiceResquests/components'



export const StatusLoteModal: FC<StatusLoteModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { pluginSpace } = usePluginsSpace()
  const isWholeSaler = Boolean(pluginSpace?.wholeSaler)


  const [items, setItems] = useState<any[]>([])
  const [selectedProducts, setSelectedProducts] = useState<TableSelection>({ selectedRows: [], selectAll: false })

  const {
    tableLoading, productFilters, loading, pagination, sorting, categories, registeredGroups,
    setTableLoading, setLoading, getProducts, setProductId, handleDataChange, handlePaginationChange,
    handleSortingChange, handleFilterChange, getCategories, getCustomersGroups, deleteProduct
  } = useProduct('statusLoteModal', 'statusLoteModal')


  async function filterProduct() {
    setTableLoading(true)
    const itensRes = await getProducts()
    setItems(itensRes)
    setTableLoading(false)
  }

  function switchStatus(params: { endpoint: string; Id: number; status: boolean }) {
    const { Id, status } = params
    const newItems = items.map(item => {
      if (item.id === Id) {
        return { ...item, status }
      }
      return item
    })
    setItems(newItems)
  }

  const columns = useMemo(
    () => createColumns({ switchStatus, isWholeSaler }),
    []
  )


  async function loadPage() {
    setLoading(true)
    await getCategories()
    if (isWholeSaler) {
      await getCustomersGroups()
    }
    const itensRes = await getProducts()
    setItems(itensRes)
    setLoading(false)
  }

  useEffect(() => {
    if (isOpen) {
      loadPage()
    } else {
      setItems([])
      setSelectedProducts({ selectedRows: [], selectAll: false })
    }
  }, [isOpen])


  const handleActivateSelecteds = () => {
    setTableLoading(true)
    const newItems = items.map((item, index) => {
      if (selectedProducts.selectedRows.includes(index)) {
        return { ...item, status: true }
      }
      return item
    })
    setItems(newItems)
    setTimeout(() => { setTableLoading(false) }, 100)
  }

  const handleDesactivateSelecteds = () => {
    setTableLoading(true)
    const newItems = items.map((item, index) => {
      if (selectedProducts.selectedRows.includes(index)) {
        return { ...item, status: false }
      }
      return item
    })
    setItems(newItems)
    setTimeout(() => { setTableLoading(false) }, 100)
  }

  const handleUpdateStatus = async () => {
    try {
      if (selectedProducts.selectedRows.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Nenhum item selecionado',
          text: 'Selecione pelo menos um item para atualizar!',
        })
        return
      }

      const itemsToUpdate = selectedProducts
        .selectedRows.map(index => items[index])


      setLoading(true)

      const response = await POST('/product/status-lote', itemsToUpdate)

      setLoading(false)

      if (response.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Estoque atualizado em lote com sucesso!',
        }).then(() => {
          setSelectedProducts({ selectedRows: [], selectAll: false })

        })
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: response.message || 'Erro ao atualizar estoque!',
        })
      }
    } catch (error: any) {
      setLoading(false)
      console.error('Erro ao atualizar inventário:', error)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: error?.message || 'Erro ao atualizar estoque!',
      })
    }
  }

  if (!isOpen) return null

  return (
    <div className='modal fade show d-block' style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div className='modal-dialog modal-xl'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Atualizar Status em Lote</h5>
            <button
              type='button'
              className='btn-close'
              onClick={onClose}
              disabled={loading}
            ></button>
          </div>
          <div className='modal-body'>
            <div className='mb-3'>
              <FilterOptions
                productFilters={productFilters}
                handleFilterChange={handleFilterChange}
                filterProduct={filterProduct}
                categories={categories}
                registeredGroups={registeredGroups}
              />
            </div>

            <div className='table-responsive' style={{ maxHeight: '550px', overflow: 'auto' }}>
              <ModularDataTable
                data={items}
                columns={columns}
                pagination={pagination}
                onPaginationChange={handlePaginationChange}
                sorting={sorting}
                onSortingChange={handleSortingChange}
                onDataChange={handleDataChange}
                //onFilterChange={handleFilterChange}
                searchable={true}
                searchPlaceholder='Pesquisar produtos...'
                loading={tableLoading}
                onSelectionChange={setSelectedProducts}
                selection={selectedProducts}
                selectable={true}
                striped={false}
                hover={false}
                size='md'
                className='table-row-bordered table-row-gray-200'
              />
            </div>

            <div className='alert alert-info mt-3'>
              <i className='bi bi-info-circle me-2'></i>
              <strong>Dica:</strong> Selecione os itens que deseja atualizar e clique em "Atualizar Estoque". Você pode pesquisar por nome ou código de referência para facilitar a seleção.
            </div>
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className='btn btn-light'
              onClick={onClose}
              disabled={loading}
            >
              {i18n.t('buttons.cancel')}
            </button>
            <button
              type='button'
              className='btn btn-light-danger'
              onClick={handleDesactivateSelecteds}
              disabled={selectedProducts.selectedRows.length === 0}
            >
              Desativar Selecionados
            </button>
            <button
              type='button'
              className='btn btn-light-success'
              onClick={handleActivateSelecteds}
              disabled={selectedProducts.selectedRows.length === 0}
            >
              Ativar Selecionados
            </button>
            <button
              type='button'
              className='btn btn-primary'
              onClick={handleUpdateStatus}
              disabled={loading || selectedProducts.selectedRows.length === 0}
            >
              {loading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' role='status'></span>
                  Atualizando...
                </>
              ) : (
                'Atualizar Estoque'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
